import { update } from '@/services/questionnaire/answerService'

const state = {}
const getters = {}
const actions = {
  async updateAnswer({commit}, {questionId, params}) {
    commit('setIsLoading', true)
    return await update(questionId, params);
  }
}

const mutations = {}

export default {
  state,
  mutations,
  actions,
  getters,
}
